import { useState, useEffect } from "react";
import Input from "../../../../../components/fields/input";
import Button from "../../../../../components/buttons/button";
import { useTranslation } from "react-i18next";

export default function EditUserModal({
  isOpen,
  closeModal,
  selectedEditRowdata,
}) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "",
    permissions: "",
    status: false,
  });

  // Populate formData when selectedEditRowdata changes
  useEffect(() => {
    if (selectedEditRowdata) {
      setFormData({
        name: selectedEditRowdata.name || "",
        email: selectedEditRowdata.email || "",
        role: selectedEditRowdata.role || "",
        permissions: selectedEditRowdata.permissions || "",
        status: selectedEditRowdata.status || false,
      });
    }
  }, [selectedEditRowdata]);

  // Handle input changes dynamically
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();


    // Example: Make an API call or handle the updated data
    try {
      // await api.updateUser(selectedEditRowdata.id, formData);
      closeModal(); // Close the modal after successful update
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 overflow-y-auto bg-black bg-opacity-70 flex items-center justify-center z-50 p-4 sm:p-0">
          <div className="rounded-lg shadow-xl w-full max-w-2xl mx-auto h-full sm:h-auto sm:max-h-[90vh] flex flex-col">
            <div className="mx-auto w-full bg-white rounded-lg shadow-lg p-4 sm:px-6 sm:py-6">
              <h1 className="text-2xl font-semibold text-gray-900 mb-6">
                {t("user_team_edit_modal_title")}
              </h1>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  {/* Name */}
                  <Input
                    label="Enter Name"
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                  {/* Email */}
                  <Input
                    label="Enter Email"
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />

                  {/* Role */}
                  <Input
                    label="Enter Role"
                    type="text"
                    name="role"
                    placeholder="Enter Role"
                    value={formData.role}
                    onChange={handleChange}
                    required
                  />

                  {/* Permissions */}
                  <Input
                    label="Enter Permissions"
                    type="text"
                    name="permissions"
                    placeholder="Enter Permissions"
                    value={formData.permissions}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 rounded-lg font-semibold text-sm border border-gray-300 text-gray-700 hover:bg-gray-100"
                  >
                    {t("universal_cancel_text")}
                  </button>


                  <Button
                    type="submit"
                    text={t("user_team_edit_modal_btn_text_update_user")}
                    className="bg-blue-600 text-white hover:bg-blue-700"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
